const DATE_FORMATTER = new Intl.DateTimeFormat('ru-RU', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric'
})

const toDate = (value: string | number): Date =>
  typeof value === 'number' ? new Date(value * 1000) : new Date(value)

/**
 * Переведёт дату с бэкенда к виду "17.09.2026 - 30.09.2026".
 * Принимает форматы дат: string - "2026-08-13" и number - "1781550000"
 * Если start/end в один день — показываем одну дату.
 */
export const getDateRangeText = (
  startAt: string | number,
  endAt: string | number
): string => {
  const startStr = DATE_FORMATTER.format(toDate(startAt))
  const endStr = DATE_FORMATTER.format(toDate(endAt))

  return startStr === endStr ? startStr : `${startStr} - ${endStr}`
}
